export enum UsageState {
  DEFAULT = 'default',
  EMBEDDED = 'embedded',
}
